import React from "react";
import { useTranslation } from "react-i18next";
import ModalBase from "../ModalBase";
import PointStatusLog from "../../components/point/PointStatusLog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from "@fortawesome/pro-regular-svg-icons";

const LogConPointModal = ({ isOpen, pointPublicId, connectorPublicId, onClose }) => {
	const { t } = useTranslation();
	return (
		<ModalBase
			isOpen={isOpen}
			onClose={onClose}
			size="xl"
			className="rounded-3xl overflow-hidden flex flex-col" // 🧹 tog bort !p-0 och behåller rundning
		>
			{/* Header */}
			<div className="flex items-center gap-2 mb-4 border-b border-mute-200 pb-2">
				<FontAwesomeIcon icon={faChartLine} className="text-sky-500 text-lg" />
				<h2 className="text-lg font-semibold text-sky-600">{t("chargeMonitor.datalog")}</h2>
			</div>

			{/* Innehåll */}
			<div className="flex-1 px-4 py-3 overflow-y-auto bg-mute-50">
				<PointStatusLog
					pointPublicId={pointPublicId}
					connectorPublicId={connectorPublicId}
					isModal={true}
				/>
			</div>
		</ModalBase>
	);
};

export default LogConPointModal;
